import { getAllCategoriesProduct } from './getAllCategoriesProduct'

export const categoriesProduct = [getAllCategoriesProduct]
